import React, {Component} from 'react';
import {
	Button,
	Modal
} from '@carbon/react';

import * as midi from '../js/rpl_midi.js';

/*
 * A ModalWrapper that displays a modal dialog showing all MIDI devices.
 */
class MidiDevicesDialogWrapper extends React.Component {
	constructor(props) {
		super(props);

		this.handleOpen  = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			isOpen : false
		};
	}

	createMidiDeviceList() {
		var elements = [];
		if (this.state.isOpen) {
			var inputs = midi.getMIDIInputs();
			var outputs = midi.getMIDIOutputs();
	
			elements.push(<h2 key="mih">MIDI Inputs</h2>);
	
			if (inputs) {
				for (let input of inputs.values()) {
					var info = '- ' + input.manufacturer + ' ' + input.name + ' (' + input.connection + ')';
					elements.push(<p key={input.id}>{info}</p>);
				}
			}

			elements.push(<h2 key="moh"><br/>MIDI Outputs</h2>);
	
			if (outputs) {
				for (let output of outputs.values()) {
					var info = '- ' + output.manufacturer + ' ' + output.name + ' (' + output.connection + ')';
					elements.push(<p key={output.id}>{info}</p>);
				}
			}
		}

		return elements;
	}

	render() {
		return (
			<div>
			  <Button kind="secondary" onClick={this.handleOpen}>
				Show MIDI Devices
			  </Button>
			  <Modal passiveModal hasScrollingContent size="md"
					modalHeading="MIDI Devices"
					open={this.state.isOpen}
					onRequestClose={this.handleClose}>
				{this.createMidiDeviceList()}
			  </Modal>
			</div>
		);
	}

	handleOpen(ev) {
		this.setState({ isOpen : true });
	}

	handleClose(ev) {
		this.setState({ isOpen : false });
	}
}

export default MidiDevicesDialogWrapper;
